<template>
  <div class="page">
    <p class="p1">
      发票抬头
      <span class="rt-pos" @click="goBack()"></span>
    </p>
    <div class="content-class">
      <div class="div-class">
        <nut-textinput v-model="queryParams.title" label="发票抬头：" placeholder="请输入抬头名称" :clearBtn="false"/>
      </div>
      <div class="div-class">
        <nut-textinput v-model="queryParams.ein" label="公司税号：" placeholder="请输入纳税人识别号" :clearBtn="false"/>
      </div>
      <div class="div-class">
        <nut-textinput v-model="queryParams.businessAddress" label="注册地址：" placeholder="请输入注册地址" :clearBtn="false"/>
      </div>
      <div class="div-class">
        <nut-textinput v-model="queryParams.businessPhone" label="注册电话：" placeholder="请输入注册电话" :clearBtn="false"/>
      </div>
      <div class="div-class">
        <nut-textinput v-model="queryParams.bank" label="开户银行：" placeholder="请输入开户银行" :clearBtn="false"/>
      </div>
      <div class="div-class">
        <nut-textinput v-model="queryParams.bankAccount" label="银行账号：" placeholder="请输入银行账号" :clearBtn="false"/>
      </div>
    </div>
    <div class="footer">
      <nut-button @click="next()">提交数据</nut-button>
    </div>
  </div>
</template>
<script>
import { wx_invoiceSaveInvoiceCompany } from "@/api/api.js"; 
export default {
  data() {
    return {
      queryParams:{}
    };
  },
  computed: {},
  methods: {
    // 后退到上一页
    goBack(){
      this.$router.go(-1);
    },
    next(){
      let params = {
        ...this.queryParams
      }
      params.code = localStorage.getItem("code");
      params.channel = localStorage.getItem("channel")
      wx_invoiceSaveInvoiceCompany(params).then(res=>{
        if(res.data.code == 200){
          this.$router.push({
            name: "invoiceXx",
          });
        }else{
          this.$toast.fail(res.data.message);
        }
      })
    }
  },
  created() {
    
  },
  mounted() {
    window.document.title = "发票抬头";
  },
};
</script>
<style scoped lang="less">
  .page{
    .p1{
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #F94040;
      color: #fff;
      font-size: 18px;
      position: relative;
      .rt-pos{
        position: absolute;
        left: 20px;
        top:14px;
        width: 12px;
        height: 12px;
        border-top: 2px solid gainsboro;
        border-left: 2px solid gainsboro;
        transform: rotate(-45deg);
      }
    }
    .content-class{
      padding: 0px 15px;
    }
    .div-class{
      margin: 20px 0;
    }
    .tai-class{
      margin-left: 10px;
      position: relative;
      top:-2px
    }
    .footer{
      background: #F8F8F8;
      padding: 15px 0;
      display: flex;
      justify-content: center;
      position: fixed;
      bottom: 0;
      width: 100%;
      z-index: 23;
      button{
        border-radius: 10px;
        width: 52%;
        font-size: 14px;
        height: 45px;
        line-height: 45px;
        border: 1px solid #F94040 !important;
      }
    }
  }
</style>

